<script>
   export let boat;

   function scaleDist(distance) {
      if (distance > 1000) {
         return (distance/1000).toFixed(2) + "\nkm"
      }
      if (distance < 100) {
         return "0\nm"
      }

      return Math.round(distance) + "\nm";
	}

   function changeDest(port, left) {
      if (port === "") {
         return "?"
      }
      return port + " (" + left + ")"
   }

   function changeStatus(status) {
      if (status === "") {
         return ""
      }
      return status
   }

   // Brukt flere steder
   function formatTime(time) {
      var t = new Date(time);
      var hours = t.getHours();
      var minutes = t.getMinutes();

      var year = t.getFullYear()
      if (year === 1) {
         return ""
      }
      var str = ""

      if (hours < 10) {
         str = str + "0" 
      }
      str = str + hours + ":" 

      if (minutes < 10) {
         str = str + "0" 
      }
      str = str + minutes 

      return str 
   }

   // TODO: Lag en maks funksjon
// maks den er laget for nå nord-hidle (23:05) Til: helgøy 
   // foreks kan stavnager-sentrum blir stav-s, kanskje ha forkortelser i DB? Under port?

   //| Til: ? (13:10) | Fart: 12km/t 
</script>

         <div class="boat center">
            <div style="float:left;">
               <div class="left">{scaleDist(boat.Distance)}</div>
               <div class="right">
                  <div>
                     <b>{boat.Name}</b><br>
                     Fra: {changeDest(boat.LastPort, formatTime(boat.Left))} <!-- Til: {changeDest(boat.NextPort, boat.NextTime)} --> | Oppdatert: {formatTime(boat.LastUpdate)}
                  </div>
               </div>
            </div>
            <div style="float:right; padding-right: 3px;">
               <div>
                  {boat.Type}
               </div>
               <div style="text-align: right;vertical-align: bottom;">
                  {changeStatus(boat.Status)}
               </div>
            </div>
         </div>

<style> 
  /*  .center {
    	margin: auto;
 		width: 90%;
      font-size: 2.4vw;
    }
   @media (min-width : 770px) {
*/
      .center {
    	   margin: auto;
 		   width: 100%;
         font-size: 2vw;
      }
 /*  } */
   /* PC */
   @media (min-width : 770px) {
      .center {
         font-size: 1.0vw;
      }
   }
        
	.boat{
 		border: 1px solid black;
       
        height: 4em;
         background-color: white;
         padding: 5px 0px 5px 5px;
         margin-bottom: 5px;
    }
    .left {

    	display: inline-block;
        width:3em;
        height: 100%;
        border-right: 1px solid black;
        text-align: center;        
    }
     .right {
     	display: inline-block;
        padding-left: 5px;
       
    }
</style> 
